export default {
  user: null,
  shop: null,
  userId: null,
  positionOptions: [],
  mottoOptions: [],
  titleOptions: [],
  secondTitleOptions: []
}
